module.exports = __webpack_public_path__ + "static/media/salida.71902228.png";